import { Component, OnInit } from '@angular/core';
import { QuoteService } from 'src/app/partner-portal/services/quote.service';
import { ProposalService } from 'src/app/partner-portal/services/proposal.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as CryptoJS from 'crypto-js';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from 'src/app/core/services/notification.service';
import { PolicyConstant } from 'src/app/partner-portal/Model/policyConstant';
import { MotorService } from '../../../../services/motor.service';

@Component({
    selector: 'app-motor-proposal-customer-view',
    templateUrl: './motor-proposal-customer-view.component.html',
    styleUrls: ['./motor-proposal-customer-view.component.css'],
    standalone: false
})
export class MotorProposalCustomerViewComponent implements OnInit {
  responseData: any;
  policyStartDate: Date;
  policyEndDate: Date
  safeHTML: SafeHtml;
  panelOpenState: boolean = true;
  isCheckedAddon: number | null = 0;
  proposalNumber: any
  tempProposalNumber: string;
  multiId: string;
  isDeclarationAccepted: boolean = true;
  status: any;
  isCustomerProposalMakePaymentSuccess: boolean = false;
  isMultiplePayment: boolean = false;
  isMultiplePaymentSuccess: boolean = false;
  constructor(private motorService: MotorService, private notificationService: NotificationService, private quoteService: QuoteService, public proposalService: ProposalService, private domSanitizer: DomSanitizer, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if ('proposalNo' in params) {
        this.tempProposalNumber = params.proposalNo;
      }
      if ('multiId' in params) {
        this.isMultiplePayment = true;
        const BASE_64_STR = params.multiId?.substring(5) || '';
        const DECODED_STR = CryptoJS.enc.Base64.parse(BASE_64_STR) || '';
        // Original code (vulnerable)
        // this.multiId = CryptoJS.enc.Utf8.stringify(DECODED_STR).replace('[', '');

        // Fixed code (replaces all occurrences)
        this.multiId = CryptoJS.enc.Utf8.stringify(DECODED_STR).replace(/\[/g, '');

        this.payment(this.multiId);
      }
      if ('multiPaymentStatus' in params) {
        this.isMultiplePayment = true;
        this.status = params.status;
        if (this.status === 'success') {
          this.isMultiplePaymentSuccess = true;
          // this.notificationService.showSuccess('Payment is succesfully and download policy from download policy button', '');
        }
        else {
          this.notificationService.showError('Payment failed. Please try again or contact support for assistance.', '');
        }
      }
      if ('status' in params && !this.isMultiplePayment) {
        this.status = params.status;
        if (this.status === 'success') {
          this.notificationService.showSuccess('Payment is succesfully', '');
          this.isCustomerProposalMakePaymentSuccess = true;
        }
        else {
          this.isCustomerProposalMakePaymentSuccess = false;
          this.notificationService.showError('Payment failed. Please try again or contact support for assistance.', '');
        }
      }
    })

    if (!this.isMultiplePayment) {
      const BASE_64_STR = this.tempProposalNumber?.substring(5) || '';
      const DECODED_STR = CryptoJS.enc.Base64.parse(BASE_64_STR) || '';
      this.tempProposalNumber = CryptoJS.enc.Utf8.stringify(DECODED_STR)?.replace('[', '')?.replace(']', '')?.trim() || this.tempProposalNumber;
      //this.proposalNumber = 'P121124315107310000052';
      this.initializeForms();
      this.quoteService.paymentPageDetails(this.tempProposalNumber).subscribe(res => {
        if (res.status === 200) {
          this.responseData = res.result;
          if (this.responseData?.isQcRequired && this.isCustomerProposalMakePaymentSuccess) {
            this.notificationService.showSuccess('Covernote has been triggered for QC', '');
          }
        }
      });
    }
  }

  public async makePayment(): Promise<void> {
    if (!this.isDeclarationAccepted) {
      this.notificationService.showError('Please accept the declaration to proceed with payment.', '');
      return;
    }
    this.proposalService.proposalNo = this.tempProposalNumber;
    const paymentLogic = await this.proposalService.getPaymentPGTypeCheck();
    this.proposalService.paymentDetailsForm.patchValue({
      paymentBy: "Customer",//hardcode
      amount: this.responseData?.totalPremiumPayable,
      paymentDueDate: new Date(),
      paymentMode: PolicyConstant.Motor_Payment_link
    });
    this.proposalService.customerDetailsForm.patchValue({
      firstName: this.responseData?.customerName,
      email: this.responseData?.customerEmail,
      mobileNo: this.responseData?.customerMobile
    });

    if (paymentLogic?.udf1 === "0") {
      let paymentHTML = await this.proposalService.getGatewayPayU(PolicyConstant.Motor_Payment_link, this.responseData?.imdCode, this.responseData?.officeCode);
      this.safeHTML = this.domSanitizer.bypassSecurityTrustHtml(paymentHTML);
      const myWindow = window.open('', '_self');
      myWindow.document.write(paymentHTML);
    }
    else if (paymentLogic?.udf1 === "1") {
      let paymentHTML = await this.proposalService.getGatewayPayU(PolicyConstant.Motor_Payment_link, this.responseData?.imdCode, this.responseData?.officeCode);
      paymentHTML = JSON.parse(paymentHTML);
      if (paymentHTML?.status !== '200') {
        this.notificationService.showError('Failed to get Payment Window!', 'Failed!');
      } else {
        const myWindow = window.open(paymentHTML?.redirectUrl, '_self');
      }
    }
  }

  isChecked(i) {
    return this.isCheckedAddon == i;
  }

  initializeForms() {
    this.proposalService.paymentDetailsForm = this.proposalService.getPaymentDetailsForm();
    this.proposalService.customerDetailsForm = this.proposalService.getCustomerKYCDetailsForm();
  }

  downloadPdf() {
    const PAYLOAD = {
      "proposalNumber": this.tempProposalNumber,
      "reportNameProposal": "Proposal_Package",
      "reportNamePolicy": "PolicySchedule_Package"
    }
    switch (this.responseData?.gcProductCode?.toString()) {
      case "2011":
        PAYLOAD.reportNameProposal = "Proposal_Package";
        PAYLOAD.reportNamePolicy = "PolicySchedule_Package";
        break;
      case "2012":
        PAYLOAD.reportNameProposal = "Proposal_Package";
        PAYLOAD.reportNamePolicy = "PolicySchedule_Package";
        break;
      case "2013":
      case "2014":
        PAYLOAD.reportNameProposal = "Proposal_Package";
        PAYLOAD.reportNamePolicy = "PolicySchedule_Package";
        break;
      case "2015":
        PAYLOAD.reportNameProposal = "Proposal_Liability";
        PAYLOAD.reportNamePolicy = "PolicySchedule_Liability";
        break;
      case "2016":
        PAYLOAD.reportNameProposal = "Proposal_Liability";
        PAYLOAD.reportNamePolicy = "PolicySchedule_Liability";
        break;
      case "2017":
      case "2018":
        PAYLOAD.reportNameProposal = "Proposal_Liability";
        PAYLOAD.reportNamePolicy = "PolicySchedule_Liability";
        break;
      case "2019":
        PAYLOAD.reportNameProposal = "CPA_Proposal";
        PAYLOAD.reportNamePolicy = "CPA_Schedule";
        break;
      case "2025":
        PAYLOAD.reportNameProposal = "Proposal_ODOnly";
        PAYLOAD.reportNamePolicy = "PolicySchedule_OD_Only";
        break;
      case "2026":
        PAYLOAD.reportNameProposal = "Proposal_ODOnly";
        PAYLOAD.reportNamePolicy = "PolicySchedule_OD_Only";
        break;
      default:
        break;
    }
    this.quoteService.downloadPolicyPdf(PAYLOAD).subscribe(blob => {
      this.motorService.downloadPdf(blob, this.responseData?.policyNumber);
    });
  }

  public async payment(proposalList: any): Promise<void> {
    let res = await this.proposalService.getGatewayPayUPage(proposalList);
    if (res) {
      this.safeHTML = this.domSanitizer.bypassSecurityTrustHtml(res);
      const myWindow = window.open('', '_self');
      myWindow.document.write(res);
    }
  }
}
